export default "__VITE_ASSET__4ca2c657__"